import { Grid, Button } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import BaseWindow from "./BaseWindow";
import unsuccess from "../../images/unsuccess.png";

export default function UnauthorizedPage(props) {
  return (
    <BaseWindow >
    <Grid item xs={12} style={{ textAlign: "center", marginTop: 50 }}>
      <div style={{ width: "100%" }}>
        <img alt="Fibabanka" src={unsuccess} width={100} height={100} />
      </div>
      <div style={{ width: "100%" }}>
        <p> 
          <b>Oturumunuz işlem süresinin dolması nedeniyle sonlandırılmıştır. </b> 
        </p>
      </div>
    </Grid>
    
  </BaseWindow>
  );
}
